// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.325.036a6.04 6.04 0 0 0-2.966 1.19A7.93 7.93 0 0 0 7.227 2.36C6.417 3.444 6 4.68 6 6c0 1.322.415 2.556 1.226 3.64.226.303.83.907 1.132 1.133C9.443 11.583 10.68 12 12 12c1.323 0 2.557-.416 3.647-1.23a7.98 7.98 0 0 0 1.121-1.122 6.095 6.095 0 0 0 1.188-2.879c.041-.3.041-1.237 0-1.536a6.09 6.09 0 0 0-1.183-2.873 7.93 7.93 0 0 0-1.132-1.132A6.03 6.03 0 0 0 11.325.036m.051 1.511a4.546 4.546 0 0 0-2.076.861 6.05 6.05 0 0 0-.892.892A4.4 4.4 0 0 0 7.513 6c0 1 .3 1.903.895 2.7.185.247.645.707.892.892a4.406 4.406 0 0 0 2.7.895c.999 0 1.904-.3 2.7-.895a6.05 6.05 0 0 0 .892-.892 4.406 4.406 0 0 0 .895-2.7c0-.999-.3-1.904-.895-2.7a6.05 6.05 0 0 0-.892-.892 4.503 4.503 0 0 0-2.088-.86 6.135 6.135 0 0 0-1.236 0m-.06 11.223a10.51 10.51 0 0 0-9.493 7.884 10.137 10.137 0 0 0-.309 2.11c-.023.518-.01.67.07.827.28.55 1.063.535 1.345-.024.048-.094.058-.163.075-.54.046-.992.177-1.748.441-2.558a9.016 9.016 0 0 1 2.975-4.275 8.946 8.946 0 0 1 4.092-1.816c.576-.094.794-.11 1.488-.11.693 0 .909.015 1.488.11a9.004 9.004 0 0 1 7.438 7.75c.02.154.051.6.082 1.175.034.62.806.925 1.25.493a.743.743 0 0 0 .229-.428c.025-.157-.01-.972-.06-1.373a10.445 10.445 0 0 0-3-6.166 10.47 10.47 0 0 0-8.111-3.06"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const AccountIcon = Icon;
export default AccountIcon;
